import { HttpClient } from "@angular/common/http";
import { IApiResponse, ISearchCtx, IStats } from "@mvm/api-interfaces";
import { API } from "./apiutil";
import { environment } from "../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TasksService {
    http;
    getTask(id) {
        return this.http.get(`${environment.base}/tasks/${id}`);
    }
    constructor(http) {
        this.http = http;
    }
    search(ctx) {
        return this.http.get(`${environment.base}/tasks`, { params: API.makeParams(ctx) });
    }
    createTask(task) {
        return this.http.post(`${environment.base}/tasks/`, task);
    }
    patchTask(task) {
        return this.http.patch(`${environment.base}/tasks/${task.id}`, task);
    }
    getDashboardStats(ctx) {
        const params = ctx ? API.makeParams(ctx) : {};
        return this.http.get(`${environment.base}/tasks/stats`, { params });
    }
    getOverDueTaskStats(ctx) {
        const params = ctx ? API.makeParams(ctx) : {};
        return this.http.get(`${environment.base}/tasks/stats/overdue`, { params });
    }
    static ɵfac = function TasksService_Factory(t) { return new (t || TasksService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TasksService, factory: TasksService.ɵfac });
}
